import { callApi } from "./api";
import { getQueryString, getOffsetLimitFromPagination } from "../utils/query";

class PatientsService {
  async getPatientsPaged({
    currentPage,
    pageSize,
    searchValue,
    cancelToken,
    orderValue,
  }) {
    if (orderValue !== "") {
      searchValue = "";
      currentPage = 1;
    }
    const query = getQueryString({
      ...getOffsetLimitFromPagination({ currentPage, pageSize }),
      search: searchValue,
      ordering: orderValue ? orderValue : "-date_edited",
    });
    return await callApi({
      url: `/api/patients/${query}`,
      cancelToken,
    });
  }

  async getAllPatients() {
    return await callApi({
      url: `/api/patients/?limit=1000`,
      method: "GET",
    });
  }

  async addPatient(data) {
    return await callApi({
      url: `/api/patients/`,
      method: "POST",
      data,
    });
  }

  async editPatient(id, data) {
    return await callApi({
      url: `/api/patients/${id}/`,
      method: "PATCH",
      data,
    });
  }

  async deletePatient(id) {
    return await callApi({
      url: `/api/patients/${id}/`,
      method: "DELETE",
    });
  }
}

export const patientsService = new PatientsService();
